import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

import type { IUpdateEmailPayload } from '@app/dashboard/types/innerLayout/profile_details/account-info';
import type { IAddDeletePhonePayload } from '@app/dashboard/types/innerLayout/profile_details/confirmation-modal';
import type { IPasswordPayload } from '@app/dashboard/types/innerLayout/profile_details/password-form';

export const getMerchantDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/merchant_details/${id}`);
};

export const updateMerchantDetails = (
  merchantId: string,
  data: IAddDeletePhonePayload | IUpdateEmailPayload
) => {
  return axiosPrivate.put(
    `/dashboard/api/v1/merchant_details/${merchantId}`,
    data
  );
};

export const changePassword = (payload: IPasswordPayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/change_password`, payload);
};
